function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-448 -408) translate(448.745 408.923)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 46.936,
  x: 2,
  y: 7.989,
  fill: "#9AFFE3",
  rx: 4.667
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 29.5,
  cy: 42.442,
  fill: "#E7E8FF",
  fillRule: "nonzero",
  rx: 11.5,
  ry: 11.484
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#001610",
  d: "M18.871 45.646c0 .51-.434.957-.931.957H6.146C2.73 46.603 0 43.283 0 39.262V4.15C0 1.85 1.614 0 3.538 0h31.473c.497 0 .931.447.931.958 0 .51-.434.957-.931.957H3.538c-.93 0-1.676 1.022-1.676 2.235 0 1.213.745 2.234 1.676 2.234h31.535c.497 0 .931.447.931.958v15.96c0 .51-.434.957-.931.957-.497 0-.993-.447-.993-.957V8.299H3.538c-.62 0-1.18-.191-1.676-.51v31.473c0 3 1.925 5.426 4.284 5.426H17.94c.559 0 .931.447.931.958zM3.414 3.192c-.496 0-.931.447-.931.958 0 .51.435.957.931.957h29.859c.496 0 .931-.447.931-.957 0-.511-.435-.958-.931-.958H3.414zm36.253 31.76c0 6.441-5.218 11.651-11.667 11.651-6.45 0-11.667-5.21-11.667-11.65 0-6.441 5.218-11.651 11.667-11.651 6.45 0 11.667 5.282 11.667 11.65z",
  transform: "translate(2 7.99)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#001610",
  d: "M40.138 35.367c0-6.403-5.255-11.65-11.667-11.65s-11.667 5.247-11.667 11.65c0 6.404 5.255 11.651 11.667 11.651s11.667-5.247 11.667-11.65z",
  transform: "translate(2 7.99)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.189 29.034c-.063-.063-.063-.063 0 0-.187-.191-.373-.255-.56-.255h-.185c-.249 0-.435.128-.621.255l-3.104 3.192c-.186.192-.248.447-.248.703 0 .255.062.51.248.702.373.383.931.383 1.304 0l1.49-1.532v7.278c0 .51.434.957.93.957.497 0 .932-.447.932-.957V31.97l1.49 1.532c.372.383.93.383 1.303 0 .373-.383.373-.957 0-1.34l-2.98-3.129z",
  transform: "translate(2 7.99) rotate(180 28.46 34.557)"
})))));

var SvgEKitap = function SvgEKitap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "2 6 40 55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEKitap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/e-kitap.2408dd21.svg";
export { ForwardRef as ReactComponent };